import React, { useState } from 'react';
import '../../../styles/Performance.css';

const LABELS = ['', 'Very Poor', 'Poor', 'Neutral', 'Good', 'Excellent'];

/**
 * StarRating
 * Props:
 *   value     — current rating (1–5, 0 = unset)
 *   onChange  — called with new rating (number)
 *   readOnly  — when true, stars are not interactive
 *   size      — 'sm' | 'md' (default 'md')
 */
export function StarRating({ value = 0, onChange, readOnly = false, size = 'md' }) {
  const [hoverValue, setHoverValue] = useState(0);
  const displayValue = hoverValue || value;
  const isSm = size === 'sm';

  return (
    <div className={`star-rating${isSm ? ' star-rating-sm' : ''}`}>
      {[1, 2, 3, 4, 5].map(star => (
        <div key={star} className="star-wrapper">
          <span
            className={`star ${star <= displayValue ? 'filled' : 'empty'}`}
            onClick={() => !readOnly && onChange?.(star)}
            onMouseEnter={() => !readOnly && setHoverValue(star)}
            onMouseLeave={() => setHoverValue(0)}
            style={{ cursor: readOnly ? 'default' : 'pointer' }}
          >
            ★
          </span>
          {!readOnly && hoverValue === star && (
            <span className="star-label">{LABELS[star]}</span>
          )}
        </div>
      ))}
      {value > 0 && !isSm && <span className="rating-value">{value}/5</span>}
    </div>
  );
}
